import { FormSettings } from "../Forms/Types/FormSettings";

import { FullFormAction } from "./Core/Store/FullFormAction";
import { FormSettingsActionType } from "./FormSettingsActions";

export function formSettingsReducer(state: FormSettings, action: FullFormAction): FormSettings {
    switch (action.type) {
        case FormSettingsActionType.SetPortalUserId:
            return {
                ...state,
                portalUserId: action.payload.value,
            };
        default:
            return state;
    }
}
